import { render, staticRenderFns } from "./BestPlaces.vue?vue&type=template&id=7b911b3f&"
import script from "./BestPlaces.vue?vue&type=script&lang=js&"
export * from "./BestPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports